import React from 'react';
import { useLocation } from 'react-router-dom';

import useWhitelabel from '@goeuro/app/client/b2b-components/src/hooks/use-whitelabel';

import { IsMobileContext } from 'contexts/mobile';
import { useGlobalState } from 'hooks';
import {
  getAbTestParameters,
  getLinksParams,
  resolveRoute,
} from 'components/ferret/Ferret.utils';
import type { ResolvedRoute } from 'components/ferret/Ferret.utils';
import usePrefillFerret from 'components/ferret/hooks/usePrefillFerret';
import type { FerretPrefillProps } from 'components/ferret/hooks/usePrefillFerret';

export interface FerretData {
  abTestParameters: string;
  arrivalId: string | null;
  currency: string;
  departureId: string | null;
  isMobile: boolean;
  locale: string;
  partnerId: string;
  prefillProps: FerretPrefillProps;
  route: ResolvedRoute | null;
  travelModes: string[];
}

function useFerretData(): FerretData {
  const isMobile = React.useContext(IsMobileContext);
  const { locale, currency } = useGlobalState();
  const { wlData } = useWhitelabel();
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  const linkParams = getLinksParams(search);
  const { arrivalInfo, departureInfo, prefillProps } = usePrefillFerret({
    locale,
    ...linkParams,
  });

  return {
    abTestParameters: getAbTestParameters(location),
    arrivalId: linkParams.arrivalPos?.toString() || null,
    currency,
    departureId: linkParams.departurePos?.toString() || null,
    isMobile,
    locale,
    partnerId: wlData.partnerId || '',
    prefillProps,
    route: resolveRoute(
      departureInfo,
      arrivalInfo,
      linkParams.departurePos,
      linkParams.arrivalPos
    ),
    travelModes: wlData.travelModes || [],
  };
}

export default useFerretData;
